/**
 * 上传文件
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/17      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import { fexWebUploaderConfig } from "@config/upload";
import {message,Spin} from 'antd';
// import {searchFileHandle} from "@utils/utils";
import "./index.less";

class UploadFile extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            imgList:this.props.defaultList && this.props.defaultList.length?this.props.defaultList:[]
        }
        this.id = Math.floor((Math.random()*10000)+1);
    }

    loading(loading){
        this.setState({
            loading:loading
        },()=>{
            this.props.changeLoading(loading);
        })
    }

    init(successFn) {
        const _this = this;
        const props = this.props;
        const WebUploader = window.WebUploader;
        var uploader =  WebUploader.create($.extend({}, fexWebUploaderConfig, {
            pick: {
                id: '#filePicker'+(props.keyName||this.id),
                multiple: this.props.multiple||false,
            },
            accept: props.accept||{
                title: 'Images',
                extensions: 'gif,jpg,jpeg,bmp,png',
                mimeTypes: 'image/*'
            },
            auto: true,
            fileSingleSizeLimit:props.fileSizeLimit||5 * 1024 * 1024,
            compress:false
        }));

        uploader.onUploadSuccess = function (file, response) {
            successFn && successFn(file, response);
            _this.setState({
                loading:false
            },()=>{
                _this.props.changeLoading(false);
            });
        };

        uploader.on('error',function (Error,fileSize) {
            console.log(Error,"Error");
            if(Error=='Q_EXCEED_SIZE_LIMIT'||Error=='F_EXCEED_SIZE'){
                message.info(`${__getServerLanguage('ZongWenJianDaXiaoChaoChuXianZhi',_this.formatBytes(props.fileSizeLimit))}`);
            }else if(Error=='Q_TYPE_DENIED'){
                message.info(`${__getServerLanguage('BuZhiChiGaiGeShiShangChuan')}`);
            }else {
                message.info(`${__getServerLanguage('ShangChuanShiBai')}`);
            }
            _this.setState({
                loading:false
            },()=>{
                _this.props.changeLoading(false);
            });
        });

        uploader.on('beforeFileQueued', function (file) {
            _this.loading(true);
        });

    }

    formatBytes(bytes,decimals) {
        if(bytes == 0) return '0 Byte';
        var k = 1024;
        var dm = decimals + 1 || 3;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    componentWillReceiveProps(nextProps,nextContext){
        if(this.props.defaultList !== nextProps.defaultList) {
            this.setState({imgList: nextProps.defaultList});
        }
    }

    componentDidMount() {
        let _this = this;
        setTimeout(()=>{
            this.init(function (file, response) {
                let imgList = [].concat(_this.state.imgList,{
                    url:response.model.url,
                    fileId:response.model.id,
                    extend:response.model.extend,
                    fileName:response.model.realName,
                });
                _this.setState({
                    imgList:imgList
                })
                _this.props.changeLoading(false);
                _this.props.onChange(imgList);
            })
        },0);
    }

    render(){
        const _this = this;
        let {imgList} = this.state;
        return (
            <Spin spinning={_this.state.loading}>
                <span className="special-upload__wrap"
                      id={"filePicker"+(this.props.keyName||this.id)}>
                    {this.props.children}
                </span>
            </Spin>
        )
    }
}

UploadFile.defaultProps = {
    onChange:function () {},
    defaultList:[],
    keyName:'',
    multiple:false,
    changeLoading:function () {

    }
}

UploadFile.propTypes = {

}
export default UploadFile;
